<div class="row m-0 mt-3" [ngClass]='{"bottom-border": (isBuyNow || isLegacyCreditApp) && !coBuyerActivated}'>
  <div [ngClass]='{
   "px-0 ": true,
   "col-12 an-status-bar": (!isBuyNow && !isLegacyCreditApp) || ((isBuyNow || isLegacyCreditApp) && coBuyerActivated),
   "buy-now-status-bar": (isBuyNow || isLegacyCreditApp) && !coBuyerActivated,
   "nodropshadow": (isBuyNow || isLegacyCreditApp) && coBuyerActivated
  }'>
    <ul class="progressmenu" [ngClass]="{'pm-buynow': isBuyNow || isLegacyCreditApp, 'coBuyer': coBuyerActivated }">
      <ng-container *ngFor="let cmp of componantList; index as i">
        <ng-container *ngIf="cmp.isVisible">

          <li>
            <span class="an-statusbar-control an-statusbar-radio-btn" (click)="loadComponent(cmp.completed && cmp.totalStep === cmp.step, cmp.groupName)"
              [ngClass]="{'an-statusbar-radio-complete': cmp.completed && cmp.totalStep === cmp.step, 'noCircle': cmp.step === -1 }">
              <input type="radio" id="customRadio1" name="" class="an-statusbar-control-input" checked="checked"
                disabled>
              <div class="an-statusbar-control-label" for="customRadio1"></div>
            </span>
            <span class="text step-title step-title">
              <div class="text-wrapper">
                <span class="text-span">
                  <span [ngClass]="{'wrap-text': !isBuyNow && !isLegacyCreditApp, 'wrap-text-buynow': isBuyNow || isLegacyCreditApp,'bold': cmp.step >= 0 && cmp.step < cmp.totalStep, 'coBuyer': coBuyerActivated}">
                    {{cmp.title}}
                  </span>

                </span>
              </div>
            </span>
          </li>

          <li *ngIf="i!== componantList.length -1">
            <span class="an-progress">
              <span class="an-progress-bar" role="progressbar"
                [ngStyle]="{'width': cmp.completed ? ((cmp.step/cmp.totalStep)*100 + '%') : '0%'}">
              </span>
            </span>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </div>
</div>
